"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProvider = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const use_query_params_1 = require("use-query-params");
const app_1 = require("@koopajs/app");
const react_router_dom_1 = require("react-router-dom");
const core_1 = require("@material-ui/core");
const AppContext_1 = require("../../AppContext");
const BasicComponent_1 = require("../BasicComponent");
const App = (props) => {
    const { isProcessing, errorMessage } = react_redux_1.useSelector(app_1.Selectors.Config.state);
    const { isProcessing: isSessionProcessing } = react_redux_1.useSelector(app_1.Selectors.Session.state);
    const { isAuthenticated } = react_redux_1.useSelector(app_1.Selectors.Session.state);
    if (isProcessing || isSessionProcessing) {
        return props.componentLoading ? (react_1.default.createElement(props.componentLoading, null)) : (react_1.default.createElement(BasicComponent_1.BasicComponent, null, "Loading config"));
    }
    if (errorMessage) {
        return props.componentError ? (react_1.default.createElement(props.componentError, { errorMessage: errorMessage })) : (react_1.default.createElement(BasicComponent_1.BasicComponent, null,
            "Error loading remote config: ",
            react_1.default.createElement("i", null, errorMessage)));
    }
    if (!isAuthenticated) {
        return props.componentAuthentication ? (react_1.default.createElement(props.componentAuthentication, null)) : (react_1.default.createElement(BasicComponent_1.BasicComponent, null, "Authentication needed"));
    }
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
};
const AppProvider = (props) => {
    const { muiTheme = {} } = props;
    return (react_1.default.createElement(AppContext_1.AppContextProvider, null,
        react_1.default.createElement(react_redux_1.Provider, { store: app_1.store },
            react_1.default.createElement(core_1.ThemeProvider, { theme: muiTheme },
                react_1.default.createElement(core_1.CssBaseline, null),
                react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                    react_1.default.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route },
                        react_1.default.createElement(App, Object.assign({}, props))))))));
};
exports.AppProvider = AppProvider;
//# sourceMappingURL=index.js.map